module.exports = __webpack_public_path__ + "static/media/icon-gallery-light.ec3a616d.svg";